






























import { Vue, Component } from "vue-property-decorator";
import ReadTo from "@/zh-website/src/views/partner/supplier/ReadTo.vue";
import { PubBiddingService } from "@/zh-website/src/views/partner/service/pubBidding";
import { RecruitService } from "@/zh-website/src/views/Recruit/service";
import { RegService } from "@common/service/base-service/reg";
import { exportFileBlobNew } from "@common/utils/downloadFile";

@Component({
  components: {
    ReadTo
  }
})
export default class BiddingRegister extends Vue {

  timer: any = null;
  countDown = 0;
  isCheck = false;
  isExpired = false;
  fileName = "";
  isDownloading = false;

  pubBiddingForm = {
    phone: "",
    code: ""
  };

  pubBiddingRules = {
    phone: [
      {
        required: true,
        message: "请填写联系人手机号",
        trigger: ["change", "blur"]
      },
      {
        pattern: RegService.PHONE, 
        message: "手机号格式错误"
      }
    ],
    code: [
      {
        required: true,
        message: "请填写验证码",
        trigger: ["change", "blur"]
      }
    ]
  };
  mounted() {
    PubBiddingService.getPubBiddingDetailFull({pubBiddingId: this.$route.params.aid}).then((res: any) => {
      if (res.success) {
        this.fileName = res.data.resourceName;
        this.isExpired = res.data.isExpired;
      } else {
        this.$message.error(res.message);
      }
    });
  }

  download() {
    console.log("submit pub bidding download");
    this.isDownloading = true;
    (this.$refs['pubBiddingForm'] as any).validate(valid => {
        if (valid) {
          if (!this.isCheck) {
            this.$message.error("请仔细阅读并同意隐私协议");
            this.isDownloading = false;
            return false;
          }
          const params = Object.assign(this.pubBiddingForm, {signStatus: true, pubBiddingId: this.$route.params.aid});
          PubBiddingService.downloadFile(params).then((res: any) => {
            if (res.type == "application/json") {
              const MSG = this.$message;
              const reader:any = new FileReader();
              reader.readAsText(res, 'utf-8');
              reader.onload = function (e) {
                MSG.error(JSON.parse(reader.result).message);
              }
            } else {
              this.pubBiddingForm.code = "";
              exportFileBlobNew(res, this.fileName);
            }
            this.isDownloading = false;
          });
        } else {
          this.isDownloading = false;
          return false;
        }
    });
  }

  getCode() {
    console.log("getCode");
    (this.$refs["pubBiddingForm"] as any).validateField("phone", err => {
      if (!err && !this.timer) {
        //调用接口成功后倒计时
        RecruitService.getCode({ phone: this.pubBiddingForm.phone }).then(() => {
        this.countDown = 60;
        this.timer = setInterval(() => {
            this.countDown--;
            if (this.countDown <= 0) {
                clearInterval(this.timer);
                this.timer = null;
                this.countDown = 0;
            }
          }, 1000);
        });
      }
    });
  }
}
